module.exports = __webpack_public_path__ + "static/media/4D.6cd5c694.svg";